module.exports = __webpack_public_path__ + "static/media/crocmedia_white.2f08eae0.png";